module.exports = __webpack_public_path__ + "img/15.8f890486.jpg";